var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintains(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 825 426.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n                fill: #030131;\n            }\n\n            .cls-2 {\n                fill: #fff;\n            }\n\n            .cls-3 {\n                fill: #333;\n            }\n\n            .cls-4,\n            .cls-5 {\n                fill: #0D57DB;\n            }\n\n            .cls-5,\n            .cls-6 {\n                opacity: .2;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Screen"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 178.2,
    y: 118.8,
    width: 459.36,
    height: 304.92,
    rx: 18.16,
    ry: 18.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M619.4,425.37H196.36c-10.93,0-19.81-8.89-19.81-19.81V136.96c0-10.93,8.89-19.81,19.81-19.81h423.03c10.93,0,19.81,8.89,19.81,19.81V405.56c0,10.93-8.89,19.81-19.81,19.81ZM196.36,120.45c-9.11,0-16.51,7.41-16.51,16.51V405.56c0,9.11,7.41,16.51,16.51,16.51h423.03c9.11,0,16.51-7.41,16.51-16.51V136.96c0-9.11-7.41-16.51-16.51-16.51H196.36Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 195.03,
    y: 129.03,
    width: 428.67,
    height: 284.55,
    rx: 16.95,
    ry: 16.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M606.75,415.23H211.98c-10.26,0-18.6-8.34-18.6-18.6V145.98c0-10.26,8.34-18.6,18.6-18.6h394.77c10.26,0,18.6,8.34,18.6,18.6v250.65c0,10.26-8.34,18.6-18.6,18.6ZM211.98,130.68c-8.44,0-15.3,6.86-15.3,15.3v250.65c0,8.44,6.86,15.3,15.3,15.3h394.77c8.44,0,15.3-6.86,15.3-15.3V145.98c0-8.44-6.86-15.3-15.3-15.3H211.98Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M202.29,163.35h411.84v-13.31c0-6.14-4.97-11.11-11.11-11.11H213.4c-6.14,0-11.11,4.97-11.11,11.11v13.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M615.78,165H200.64v-14.96c0-7.04,5.72-12.76,12.76-12.76h389.62c7.04,0,12.76,5.72,12.76,12.76v14.96Zm-411.84-3.3h408.54v-11.66c0-5.22-4.24-9.46-9.46-9.46H213.4c-5.22,0-9.46,4.24-9.46,9.46v11.66Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 216.48,
    cy: 151.14,
    r: 6.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.48,159.06c-4.37,0-7.92-3.55-7.92-7.92s3.55-7.92,7.92-7.92,7.92,3.55,7.92,7.92-3.55,7.92-7.92,7.92Zm0-12.54c-2.55,0-4.62,2.07-4.62,4.62s2.07,4.62,4.62,4.62,4.62-2.07,4.62-4.62-2.07-4.62-4.62-4.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 240.9,
    cy: 151.14,
    r: 6.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.9,159.06c-4.37,0-7.92-3.55-7.92-7.92s3.55-7.92,7.92-7.92,7.92,3.55,7.92,7.92-3.55,7.92-7.92,7.92Zm0-12.54c-2.55,0-4.62,2.07-4.62,4.62s2.07,4.62,4.62,4.62,4.62-2.07,4.62-4.62-2.07-4.62-4.62-4.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 264,
    cy: 151.14,
    r: 6.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264,159.06c-4.37,0-7.92-3.55-7.92-7.92s3.55-7.92,7.92-7.92,7.92,3.55,7.92,7.92-3.55,7.92-7.92,7.92Zm0-12.54c-2.55,0-4.62,2.07-4.62,4.62s2.07,4.62,4.62,4.62,4.62-2.07,4.62-4.62-2.07-4.62-4.62-4.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 204.93,
    y: 175.23,
    width: 175.56,
    height: 222.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M382.14,399.3H203.28V173.58h178.86v225.72Zm-175.56-3.3h172.26V176.88H206.58v219.12Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M613.8,222.96h-14.57c-4.47,0-8.09,3.62-8.09,8.09v26.98c0,5.07-4.11,9.17-9.17,9.17h0c-5.07,0-9.17-4.11-9.17-9.17v-26.17c0-4.92-3.99-8.9-8.9-8.9h0c-4.92,0-8.9,3.99-8.9,8.9v45.87c0,4.62-3.74,8.36-8.36,8.36h0c-4.62,0-8.36-3.74-8.36-8.36v-19.56c0-3.35-2.72-6.07-6.07-6.07h-1.89c-4.55,0-8.23-3.68-8.23-8.23v-61.38h91.74v40.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M546.61,287.09c-5.16,0-9.35-4.2-9.35-9.35v-19.56c0-2.8-2.28-5.08-5.08-5.08h-1.89c-5.08,0-9.22-4.14-9.22-9.22v-62.38h93.72v42.45h-15.56c-3.92,0-7.1,3.19-7.1,7.1v26.98c0,5.6-4.56,10.16-10.16,10.16s-10.16-4.56-10.16-10.16v-26.17c0-4.36-3.55-7.91-7.91-7.91s-7.91,3.55-7.91,7.91v45.87c0,5.16-4.2,9.35-9.35,9.35Zm-23.56-103.61v60.4c0,3.99,3.25,7.24,7.24,7.24h1.89c3.89,0,7.06,3.17,7.06,7.06v19.56c0,4.07,3.31,7.37,7.37,7.37s7.37-3.31,7.37-7.37v-45.87c0-5.46,4.44-9.89,9.89-9.89s9.89,4.44,9.89,9.89v26.17c0,4.51,3.67,8.18,8.18,8.18s8.18-3.67,8.18-8.18v-26.98c0-5.01,4.08-9.08,9.08-9.08h13.58v-38.49h-89.76Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 538.25,
    y: 295.27,
    width: 16.19,
    height: 18.89,
    rx: 8.09,
    ry: 8.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M546.34,315.81c-5.37,0-9.74-4.37-9.74-9.74v-2.7c0-5.37,4.37-9.74,9.74-9.74s9.74,4.37,9.74,9.74v2.7c0,5.37-4.37,9.74-9.74,9.74Zm0-18.89c-3.55,0-6.44,2.89-6.44,6.44v2.7c0,3.55,2.89,6.44,6.44,6.44s6.44-2.89,6.44-6.44v-2.7c0-3.55-2.89-6.44-6.44-6.44Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Heavy_equipment"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "152.78 .66 119.51 .66 119.51 34.78 54.68 34.78 54.68 68.91 117.8 68.91 117.8 422.09 151.93 422.09 152.78 68.91 281.6 70.61 248.33 35.64 152.78 35.64 152.78 .66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.57,70.49h-.79s.04-36.56,.04-36.56h.79s1.41,0,1.41,0l30.78,.08h.84s30.53,.08,30.53,.08V0h36.56V34.18l29.43,.07h.93s31.25,.08,31.25,.08l32.46-.38,.45,.46,.85,.87,34.74,35.44-34.78,.21v.04h-4.19s-1.06,0-1.06,0h0s-25.33-.07-25.33-.07h-.31s-31.88-.08-31.88-.08h-.27s-32.3-.08-32.3-.08V422.81h-36.56V70.73h-.36l.07-.08-27.95-.07h-.53s-33.38-.08-33.38-.08h-1.45Zm3.19-6.22l12.35-12.32-12.32-11.89-.03,24.22Zm14.6-14.57l12.55-12.52-25.59-.06,13.04,12.58Zm75.75,336.94l-11.79-11.79-11.42,11.79h23.21Zm-24.12,3.18l12.13,12.13,11.68-12.13h-23.82Zm27.56-4.23v-26.46l-13.02,13.44,13.02,13.02Zm-3.75-27.16h-23.41l11.89,11.89,11.52-11.89Zm.78-3.18l-12.09-12.4-11.49,12.4h23.59Zm2.97-1.5v-27.15l-12.9,13.92,12.9,13.23Zm-3.64-27.9h-23.57l12.08,12.39,11.48-12.39Zm1.46-3.18l-12.66-13.14-11.97,13.14h24.62Zm2.18-2.32v-27.11l-12.69,13.93,12.69,13.18Zm-3.6-27.88h-23.25l11.95,12.41,11.3-12.41Zm1.35-3.18l-12.58-12.58-11.88,12.58h24.46Zm2.25-2.25v-26.04l-12.65,13.39,12.65,12.65Zm-3.69-26.76h-23.07l11.87,11.87,11.21-11.87Zm.92-3.18l-12.15-11.55-11.62,11.55h23.78Zm2.77-1.76v-24.62l-12.67,12.58,12.67,12.03Zm-3.86-25.27h-22.74l11.62,11.04,11.12-11.04Zm1.32-3.18l-12.32-12.93-11.92,12.93h24.24Zm2.54-1.95v-27.1l-12.69,13.77,12.69,13.33Zm-3.63-27.86h-22.9l11.64,12.22,11.26-12.22Zm1.38-3.18l-12.58-12.58-11.88,12.58h24.46Zm2.25-2.25v-26.04l-12.65,13.39,12.65,12.65Zm-3.69-26.76h-23.07l11.87,11.87,11.21-11.87Zm1.04-3.18l-12.29-12.29-11.75,12.29h24.04Zm2.65-1.85v-26.05l-12.73,13.32,12.73,12.73Zm-3.72-26.76h-23.04l11.78,11.78,11.26-11.78Zm1.07-3.18l-12.23-12.23-11.62,12.23h23.85Zm2.65-1.85v-26.04l-12.69,13.36,12.69,12.69Zm-3.7-26.76h-23.06l11.82,11.82,11.23-11.82Zm.93-3.18l-12.06-11.46-11.68,11.46h23.74Zm2.77-1.76v-24.25l-12.56,12.32,12.56,11.93Zm-3.1-25.66h-23.92l12.15,11.54,11.77-11.54Zm38.85-5.52l12.6-12.57-12.57-11.9-.03,24.46Zm-3.15-24.6l-12.42,11.93,12.39,11.31,.03-23.25Zm-1.27-3.19l-27.79-.07,14.29,13.04,13.5-12.97Zm-33.37-3.85l-12.63-12.63-12.02,12.63h24.64Zm-.9,33.97c-2.7-2.83-7.11-7.46-11.7-12.28l-.59-.55-11.36,12.78,23.65,.06Zm-14.85-15.21l-12.39-11.51v11.71s-.01,11.86-.01,11.86l12.4-12.06Zm-9.56-15.05c2.7,2.84,7.26,7.64,12.03,12.65l.56-.54,10.71-12.05-23.3-.06Zm26.55,26.5l.03-23.57-11.69,11.37-.63,.7c.23,.24,.45,.47,.68,.71l11.61,10.78Zm-32.57-23.54l-11.89,11.86,11.88,11.53v-11.63s.01-11.77,.01-11.77Zm36.56,1.09v23.14l12.35-11.86-12.35-11.27Zm-50.7,13.01l-13.08,13.05,26.6,.07-13.51-13.12Zm-14.09,9.56l11.8-11.78-11.78-11.43-.03,23.21Zm-3.15-24.12l-12.15,12.12,12.12,11.7,.03-23.82Zm17.21,10.1l12.65-12.63-25.73-.06,13.07,12.69Zm17.35-17.24l13.27-13.95-13.27-13.27v27.23Zm2.25-29.47l13.22,13.22,12.58-13.22h-25.8Zm27.95,2.35l-12.49,13.12,12.49,12.49V5.53Zm50.6,44.88l12.92-12.89-26.61-.07,13.69,12.96Zm44.74,17.38l.03-27.24-25.89,27.19,24.82,.06h1.03Zm-27.4-3.05l25.85-27.15-25.82-.06-.03,27.21Zm-3.15-23.99l-11.88,11.85,11.85,11.22,.02-23.07Zm60.98,26.86l-27.22-27.77-.03,27.94,27.25-.17Zm-75.11-12.76l-12.84,12.81,26.44,.07-13.6-12.88Zm-32.78-.08l-13.32,12.8h.11s27.31,.08,27.31,.08l-14.11-12.88Zm-17.88,335.77l-13.17,13.68,13.17,13.17v-26.85Zm-3.04,28.31l-12.34-12.34-11.88,12.34h24.22Zm-27.16-1.53l12.57-13.06-12.57-12.57v25.63Zm0-31.56l12.72-13.14-12.72-12.72v25.86Zm0-31.24l12.91-13.93-12.91-13.24v27.17Zm0-32.83l13.16-14.45-13.16-13.66v28.11Zm0-33.33l13.12-13.89-13.12-13.12v27.02Zm0-32.1l12.97-12.89-12.97-12.32v25.21Zm0-30.32l13.15-14.27-13.15-13.81v28.08Zm0-32.95l13.12-13.89-13.12-13.12v27.02Zm0-32.17l13.02-13.62-13.02-13.02v26.64Zm0-31.59l13.07-13.76-13.07-13.07v26.84Zm0-31.9l13.07-12.82-13.07-12.41v25.23Zm-35.25-29.93l-13.71-13.23-13.19,13.16,26.9,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.23,267.19l-2.44-2.22,35.34-38.75c5.5-6.03,13.59-8.82,21.63-7.46l56,9.46-.55,3.25-56-9.46c-6.94-1.17-13.91,1.23-18.65,6.43l-35.34,38.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.74,210.63v-8.84c-4.01-.4-7.15-3.75-7.15-7.87s3.14-7.46,7.15-7.87V68.35h1.59v117.7c4.01,.4,7.15,3.75,7.15,7.87s-3.14,7.46-7.15,7.87v10.41h-.79c-5.39,0-7.5,3.28-7.67,6.35-.16,2.83,1.39,6.02,4.58,6.38,2.22,.25,3.96-.17,5.16-1.24,1.85-1.63,1.9-4.31,1.9-4.34h1.59c0,.15-.05,3.41-2.43,5.52-1.28,1.14-2.97,1.72-5.03,1.72-.44,0-.9-.03-1.37-.08-4.15-.46-6.18-4.49-5.99-8.04,.19-3.47,2.54-7.5,8.46-7.82Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.66,
    y: 242.8,
    width: 134.29,
    height: 57.24,
    transform: "translate(-69.55 103.79) rotate(-18)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.73,321.47l-18.71-57.57,130.85-42.53,18.71,57.57-130.85,42.53Zm-14.55-55.45l16.67,51.3,124.57-40.49-16.67-51.3-124.57,40.49Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 84.13,
    y: 407.89,
    width: 104.94,
    height: 16.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.72,425.7H82.48v-19.46h108.24v19.46Zm-104.94-3.3h101.64v-12.86H85.78v12.86Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Enviroment"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "802.56 414.48 775.5 414.48 777.76 401.94 779.08 394.68 780.56 386.43 781.88 379.17 784.08 366.96 793.98 366.96 796.18 379.17 797.5 386.43 798.98 394.68 800.3 401.94 802.56 414.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M803.74,415.47h-29.43l8.94-49.5h11.56l8.94,49.5Zm-27.06-1.98h24.69l-8.22-45.54h-8.24l-8.22,45.54Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 767.91,
    y: 414.81,
    width: 42.9,
    height: 9.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M811.8,425.04h-44.88v-11.22h44.88v11.22Zm-42.9-1.98h40.92v-7.26h-40.92v7.26Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "797.5 386.43 780.56 386.43 781.88 379.17 796.18 379.17 797.5 386.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "800.3 401.94 777.76 401.94 779.08 394.68 798.98 394.68 800.3 401.94"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Enviroment-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "586.08 414.48 559.02 414.48 561.28 401.94 562.6 394.68 564.08 386.43 565.4 379.17 567.6 366.96 577.5 366.96 579.7 379.17 581.02 386.43 582.5 394.68 583.82 401.94 586.08 414.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M587.26,415.47h-29.43l8.94-49.5h11.56l8.94,49.5Zm-27.06-1.98h24.69l-8.22-45.54h-8.24l-8.22,45.54Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 551.43,
    y: 414.81,
    width: 42.9,
    height: 9.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M595.32,425.04h-44.88v-11.22h44.88v11.22Zm-42.9-1.98h40.92v-7.26h-40.92v7.26Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "581.02 386.43 564.08 386.43 565.4 379.17 579.7 379.17 581.02 386.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "583.82 401.94 561.28 401.94 562.6 394.68 582.5 394.68 583.82 401.94"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Enviroment-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "271.26 415.14 244.2 415.14 246.46 402.6 247.78 395.34 249.26 387.09 250.58 379.83 252.78 367.62 262.68 367.62 264.88 379.83 266.2 387.09 267.68 395.34 269 402.6 271.26 415.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.44,416.13h-29.43l8.94-49.5h11.55l8.94,49.5Zm-27.06-1.98h24.69l-8.22-45.54h-8.25l-8.22,45.54Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 236.61,
    y: 415.47,
    width: 42.9,
    height: 9.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.5,425.7h-44.88v-11.22h44.88v11.22Zm-42.9-1.98h40.92v-7.26h-40.92v7.26Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "266.2 387.09 249.26 387.09 250.58 379.83 264.88 379.83 266.2 387.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "269 402.6 246.46 402.6 247.78 395.34 267.68 395.34 269 402.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.44,
    y: 423.39,
    width: 802.56,
    height: 2.64
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cloud"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M393.03,51.81h58.08c3.65,0,6.6,2.95,6.6,6.6h0c0,3.65-2.95,6.6-6.6,6.6h-8.58c-3.28,0-5.94,2.66-5.94,5.94h0c0,3.28,2.66,5.94,5.94,5.94h18.15c3.83,0,6.93,3.1,6.93,6.93h0c0,3.83-3.1,6.93-6.93,6.93h-89.76c-3.83,0-6.93-3.1-6.93-6.93h0c0-3.83,3.1-6.93,6.93-6.93h35.97c3.28,0,5.94-2.66,5.94-5.94h0c0-3.28-2.66-5.94-5.94-5.94h-13.86c-3.65,0-6.6-2.95-6.6-6.6h0c0-3.65,2.95-6.6,6.6-6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.68,91.74h-89.76c-4.37,0-7.92-3.55-7.92-7.92s3.55-7.92,7.92-7.92h35.97c2.73,0,4.95-2.22,4.95-4.95s-2.22-4.95-4.95-4.95h-13.86c-4.19,0-7.59-3.4-7.59-7.59s3.4-7.59,7.59-7.59h58.08c4.18,0,7.59,3.4,7.59,7.59s-3.41,7.59-7.59,7.59h-8.58c-2.73,0-4.95,2.22-4.95,4.95s2.22,4.95,4.95,4.95h18.15c4.37,0,7.92,3.55,7.92,7.92s-3.55,7.92-7.92,7.92Zm-89.76-13.86c-3.28,0-5.94,2.66-5.94,5.94s2.66,5.94,5.94,5.94h89.76c3.28,0,5.94-2.66,5.94-5.94s-2.66-5.94-5.94-5.94h-18.15c-3.82,0-6.93-3.11-6.93-6.93s3.11-6.93,6.93-6.93h8.58c3.09,0,5.61-2.52,5.61-5.61s-2.52-5.61-5.61-5.61h-58.08c-3.09,0-5.61,2.52-5.61,5.61s2.52,5.61,5.61,5.61h13.86c3.82,0,6.93,3.11,6.93,6.93s-3.11,6.93-6.93,6.93h-35.97Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 663.63,
    y: 132.33,
    width: 40.26,
    height: 13.86,
    rx: 6.93,
    ry: 6.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M696.96,147.18h-26.4c-4.37,0-7.92-3.55-7.92-7.92s3.55-7.92,7.92-7.92h26.4c4.37,0,7.92,3.55,7.92,7.92s-3.55,7.92-7.92,7.92Zm-26.4-13.86c-3.28,0-5.94,2.66-5.94,5.94s2.66,5.94,5.94,5.94h26.4c3.28,0,5.94-2.66,5.94-5.94s-2.66-5.94-5.94-5.94h-26.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 475.53,
    y: 76.89,
    width: 31.02,
    height: 13.86,
    rx: 6.93,
    ry: 6.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M499.62,91.74h-17.16c-4.37,0-7.92-3.55-7.92-7.92s3.55-7.92,7.92-7.92h17.16c4.37,0,7.92,3.55,7.92,7.92s-3.55,7.92-7.92,7.92Zm-17.16-13.86c-3.28,0-5.94,2.66-5.94,5.94s2.66,5.94,5.94,5.94h17.16c3.28,0,5.94-2.66,5.94-5.94s-2.66-5.94-5.94-5.94h-17.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.03,151.47h58.08c3.65,0,6.6,2.95,6.6,6.6h0c0,3.65-2.95,6.6-6.6,6.6h-8.58c-3.28,0-5.94,2.66-5.94,5.94h0c0,3.28,2.66,5.94,5.94,5.94h18.15c3.83,0,6.93,3.1,6.93,6.93h0c0,3.83-3.1,6.93-6.93,6.93H7.92c-3.83,0-6.93-3.1-6.93-6.93H.99c0-3.83,3.1-6.93,6.93-6.93H43.89c3.28,0,5.94-2.66,5.94-5.94h0c0-3.28-2.66-5.94-5.94-5.94h-13.86c-3.65,0-6.6-2.95-6.6-6.6h0c0-3.65,2.95-6.6,6.6-6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.68,191.4H7.92c-4.37,0-7.92-3.55-7.92-7.92s3.55-7.92,7.92-7.92H43.89c2.73,0,4.95-2.22,4.95-4.95s-2.22-4.95-4.95-4.95h-13.86c-4.19,0-7.59-3.4-7.59-7.59s3.4-7.59,7.59-7.59h58.08c4.19,0,7.59,3.4,7.59,7.59s-3.4,7.59-7.59,7.59h-8.58c-2.73,0-4.95,2.22-4.95,4.95s2.22,4.95,4.95,4.95h18.15c4.37,0,7.92,3.55,7.92,7.92s-3.55,7.92-7.92,7.92ZM7.92,177.54c-3.28,0-5.94,2.66-5.94,5.94s2.66,5.94,5.94,5.94H97.68c3.28,0,5.94-2.66,5.94-5.94s-2.66-5.94-5.94-5.94h-18.15c-3.82,0-6.93-3.11-6.93-6.93s3.11-6.93,6.93-6.93h8.58c3.09,0,5.61-2.52,5.61-5.61s-2.52-5.61-5.61-5.61H30.03c-3.09,0-5.61,2.52-5.61,5.61s2.52,5.61,5.61,5.61h13.86c3.82,0,6.93,3.11,6.93,6.93s-3.11,6.93-6.93,6.93H7.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.09,
    y: 198.33,
    width: 31.02,
    height: 13.86,
    rx: 6.93,
    ry: 6.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.18,213.18h-17.16c-4.37,0-7.92-3.55-7.92-7.92s3.55-7.92,7.92-7.92h17.16c4.37,0,7.92,3.55,7.92,7.92s-3.55,7.92-7.92,7.92Zm-17.16-13.86c-3.28,0-5.94,2.66-5.94,5.94s2.66,5.94,5.94,5.94h17.16c3.28,0,5.94-2.66,5.94-5.94s-2.66-5.94-5.94-5.94h-17.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 711.15,
    y: 132.33,
    width: 19.8,
    height: 13.86,
    rx: 6.93,
    ry: 6.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M724.02,147.18h-5.94c-4.37,0-7.92-3.55-7.92-7.92s3.55-7.92,7.92-7.92h5.94c4.37,0,7.92,3.55,7.92,7.92s-3.55,7.92-7.92,7.92Zm-5.94-13.86c-3.28,0-5.94,2.66-5.94,5.94s2.66,5.94,5.94,5.94h5.94c3.28,0,5.94-2.66,5.94-5.94s-2.66-5.94-5.94-5.94h-5.94Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Man"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M713.55,230.53l-12.28,5.85c0-.24-1.69-6.31-2.76-10.09-.38-1.35-.67-2.4-.78-2.79-.03-.11-.05-.17-.05-.17,0,0-13.25,8.24-13.25-16.34s20.16-11.97,21.43-6.3c.57,2.58,.27,8.01,1.15,13.16,1.06,6.22,6.55,16.68,6.55,16.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M700.27,237.94v-1.49c-.13-.61-1.18-4.44-2.72-9.9l-.51-1.81c-1.63,.71-4.74,1.61-7.66-.01-3.95-2.2-5.96-8.17-5.96-17.75,0-12.06,4.72-15.11,8.67-15.54,6.27-.7,13.86,5.21,14.71,9.02,.28,1.26,.36,3.07,.46,5.17,.11,2.48,.24,5.29,.71,8.04,1.02,5.99,6.39,16.29,6.45,16.39l.48,.91-14.63,6.96Zm-2.03-16.13l.58,1.95,.63,2.26c1.44,5.11,2.13,7.65,2.47,8.94l10.27-4.89c-1.37-2.72-5.27-10.78-6.18-16.06-.49-2.87-.62-5.75-.73-8.29-.09-2.01-.17-3.74-.41-4.83-.6-2.7-7.07-8.09-12.56-7.48-5.71,.63-6.91,7.73-6.91,13.58,0,8.67,1.7,14.21,4.93,16.02,3.09,1.73,6.78-.49,6.81-.52l1.09-.67Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 673.18,
    y: 407.19,
    width: 12.05,
    height: 10.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M686.22,419.13h-14.02v-12.93h14.02v12.93Zm-12.05-1.98h10.07v-8.97h-10.07v8.97Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "729.03 407.19 732.86 418.14 744.9 418.14 741.07 407.19 729.03 407.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M746.3,419.13h-14.14l-4.53-12.93h14.14l4.53,12.93Zm-12.74-1.98h9.95l-3.14-8.97h-9.95l3.14,8.97Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "695.26 236.75 680.98 253.07 668.54 262.16 675.71 269.33 696.56 256.3 695.26 236.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M675.57,270.59l-8.54-8.54,13.29-9.72,15.78-18.03,1.5,22.53-22.02,13.77Zm-5.51-8.31l5.79,5.79,19.68-12.3-1.1-16.57-12.77,14.6-.09,.07-11.51,8.42Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M700.47,305.83l-10.19,28.02-1.51,75.26h-18.27l-4.24-72.32c-.21-3.65,.36-7.31,1.68-10.72l18.59-47.97,15.9-.3-1.96,28.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M689.74,410.1h-20.18l-.05-.93-4.24-72.32c-.22-3.82,.36-7.56,1.75-11.13l18.83-48.59,17.65-.33-2.04,29.24-10.18,28-1.53,76.06Zm-18.31-1.98h16.37l1.49-74.45,.06-.15,10.14-27.89,1.87-26.81-14.16,.26-18.35,47.35c-1.28,3.3-1.82,6.76-1.62,10.3l4.18,71.39Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M685.48,281.71l5.53,41.3c.52,3.9,1.58,7.72,3.15,11.33l32.15,74.22h18.9l-28.77-84.59,1.63-41.6-32.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M746.59,409.55h-20.93l-.26-.6-32.15-74.22c-1.6-3.7-2.69-7.6-3.22-11.59l-5.68-42.44,34.75,.69-1.67,42.43,29.16,85.73Zm-19.63-1.98h16.87l-28.38-83.46,1.6-40.78-30.42-.61,5.37,40.15c.51,3.81,1.55,7.54,3.07,11.07l31.89,73.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M677.82,297s5.05-55.03,19.39-68.06c0,0,11.76,.68,15.02-4.54,0,0,9.75,10.39,11.79,48.98l-1.93,32.2-44.27-8.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M723.02,306.78l-46.28-8.97,.08-.9c.01-.14,1.3-13.99,4.33-29.25,4.1-20.63,9.27-33.91,15.38-39.46l.31-.28,.42,.02c3.12,.17,11.71-.21,14.12-4.07l.69-1.1,.89,.95c.41,.44,10.02,11.1,12.06,49.62v.06s0,.06,0,.06l-1.99,33.33Zm-44.12-10.59l42.26,8.19,1.85-31c-1.67-31.45-8.56-44.03-10.81-47.34-3.85,4.01-12.56,3.98-14.63,3.92-12.69,12.18-17.95,59.13-18.68,66.24Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 680.92,
    y: 191.13,
    width: 32.58,
    height: 165.53,
    transform: "translate(384.32 954.5) rotate(-86.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M779.86,295.89l-.99-.06-166.25-9.42,1.95-34.51,.99,.06,166.25,9.42-1.95,34.51Zm-165.15-11.34l163.29,9.25,1.73-30.56-163.29-9.25-1.73,30.56Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 692.68,
    y: 190.78,
    width: 8.47,
    height: 153.8,
    transform: "translate(390.24 948.33) rotate(-86.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M774.38,277.3l-.99-.06-154.54-8.76,.59-10.43,.99,.06,154.54,8.76-.59,10.44Zm-153.44-10.68l151.58,8.59,.37-6.48-151.57-8.59-.37,6.48Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M700.47,252.39h13.03v11.19c0,3.99-2.04,7.7-5.4,9.83l-28.48,18.08-9.12,1.96-6.58-3.54c-.49-.27-.31-1.02,.26-1.02h10.89l-3.36-2.62c-.84-.66-.31-2.01,.76-1.91l6.51,.62,21.51-19.55v-13.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M670.35,294.49l-6.9-3.72c-.63-.34-.93-1.03-.76-1.72,.17-.69,.77-1.16,1.48-1.16h8.01l-1.09-.85c-.73-.57-.99-1.53-.65-2.39,.34-.86,1.2-1.38,2.11-1.29l6.07,.58,20.86-18.96v-13.59h15.01v12.18c0,4.35-2.19,8.34-5.86,10.67l-28.63,18.17-9.65,2.07Zm-4.4-4.62l4.69,2.53,8.59-1.84,28.33-17.98c3.1-1.97,4.94-5.33,4.94-9v-10.2h-11.05v12.48l-22.15,20.14-6.94-.67s-.06,0-.08,.05c-.02,.06,0,.07,.03,.09l5.63,4.39h-11.98Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 629.79,
    y: 274.22,
    width: 7.82,
    height: 6.52,
    transform: "translate(320.82 894.46) rotate(-86.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M637.66,282.61l-8.48-.48,.55-9.78,8.48,.48-.55,9.78Zm-6.39-2.35l4.53,.26,.33-5.83-4.53-.26-.33,5.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 640.85,
    y: 274.84,
    width: 7.82,
    height: 6.52,
    transform: "translate(330.63 906.09) rotate(-86.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M648.72,283.23l-8.48-.48,.55-9.78,8.48,.48-.55,9.78Zm-6.4-2.35l4.53,.26,.33-5.83-4.53-.26-.33,5.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M673.18,413.5s5.44,6.31,12.3,0l2.1,7.76c.47,1.74-.84,3.45-2.64,3.45h-31.1c-1.34,0-1.73-1.83-.51-2.38l19.85-8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M684.94,425.7h-31.1c-1.08,0-1.96-.71-2.18-1.77s.29-2.06,1.27-2.5l20.52-9.14,.48,.55c.05,.05,2.05,2.29,4.98,2.45,1.96,.12,3.96-.74,5.9-2.53l1.2-1.1,2.52,9.34c.3,1.13,.07,2.31-.64,3.24-.71,.93-1.79,1.46-2.96,1.46Zm-11.98-11.02l-19.23,8.56c-.05,.02-.19,.08-.14,.28,.04,.2,.19,.2,.25,.2h31.1c.55,0,1.05-.25,1.39-.69,.33-.44,.44-.99,.3-1.52l-1.69-6.28c-1.99,1.47-4.06,2.16-6.15,2.04-2.81-.16-4.89-1.74-5.82-2.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M731.76,413.5s5.44,6.31,12.3,0l2.1,7.76c.47,1.74-.84,3.45-2.64,3.45h-31.1c-1.34,0-1.73-1.83-.51-2.38l19.85-8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M743.52,425.7h-31.1c-1.08,0-1.96-.71-2.18-1.77-.22-1.06,.29-2.06,1.27-2.5l20.52-9.14,.48,.55c.05,.05,2.05,2.29,4.98,2.45,1.96,.12,3.96-.74,5.9-2.53l1.2-1.1,2.52,9.34c.3,1.13,.07,2.31-.64,3.24-.71,.93-1.79,1.46-2.96,1.46Zm-11.98-11.02l-19.23,8.56c-.05,.02-.19,.08-.14,.28,.04,.2,.19,.2,.25,.2h31.1c.55,0,1.05-.25,1.39-.69,.33-.44,.44-.99,.3-1.52l-1.69-6.28c-1.99,1.47-4.06,2.16-6.15,2.04-2.81-.16-4.89-1.74-5.82-2.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 618.79,
    y: 273.41,
    width: 7.83,
    height: 6.53,
    transform: "translate(311.24 882.73) rotate(-86.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M626.67,281.81l-8.49-.48,.55-9.8,8.49,.48-.55,9.8Zm-6.41-2.35l4.54,.26,.33-5.84-4.54-.26-.33,5.84Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M710.82,199.98c-1.44-2.88-2.64-3.96-5.94-4.62,0,0-15.84-12.54-21.78,5.28,0,0,2.57,1.64,5.09,2.63,2.31,.9,4.57,1.15,4.81,1.33,1.21,.92-.66,3.96,1.81,4.9,0,0,.17-2.26,2.81-2.92,.85-.21,3.96-.66,3.96,5.28,0,2.64,5.28,5.28,7.26,5.28,0,0,5.94-9.24,1.98-17.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Woman"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 410.84,
    y: 406.53,
    width: 12.05,
    height: 10.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M423.88,418.47h-14.03v-12.93h14.03v12.93Zm-12.05-1.98h10.07v-8.97h-10.07v8.97Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M422.89,412.84s-5.44,6.31-12.3,0l-2.1,7.76c-.47,1.74,.84,3.45,2.64,3.45h31.1c1.34,0,1.73-1.83,.51-2.38l-19.85-8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M442.23,425.04h-31.1c-1.17,0-2.25-.53-2.96-1.46-.71-.93-.94-2.11-.64-3.24l2.52-9.34,1.2,1.1c1.95,1.79,3.94,2.65,5.92,2.53,2.96-.17,4.94-2.43,4.96-2.45l.48-.56,20.52,9.14c.99,.44,1.5,1.45,1.27,2.5s-1.1,1.77-2.18,1.77Zm-31.09-10.46l-1.69,6.28c-.14,.53-.03,1.08,.3,1.52,.33,.44,.84,.69,1.39,.69h31.1c.06,0,.2,0,.25-.2,.04-.2-.09-.26-.14-.28l-19.23-8.56c-.92,.85-3,2.44-5.82,2.6-2.09,.13-4.16-.56-6.15-2.04Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 443.18,
    y: 406.53,
    width: 12.05,
    height: 10.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M456.22,418.47h-14.03v-12.93h14.03v12.93Zm-12.05-1.98h10.06v-8.97h-10.06v8.97Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M455.23,412.84s-5.44,6.31-12.3,0l-2.1,7.76c-.47,1.74,.84,3.45,2.64,3.45h31.1c1.34,0,1.73-1.83,.51-2.38l-19.85-8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.57,425.04h-31.1c-1.17,0-2.25-.53-2.96-1.46-.71-.93-.94-2.11-.64-3.24l2.52-9.34,1.2,1.1c1.95,1.79,3.94,2.65,5.92,2.53,2.96-.17,4.94-2.43,4.96-2.45l.48-.56,20.52,9.14c.99,.44,1.5,1.45,1.27,2.5s-1.1,1.77-2.18,1.77Zm-31.09-10.46l-1.69,6.28c-.14,.53-.03,1.08,.3,1.52,.33,.44,.84,.69,1.39,.69h31.1c.06,0,.2,0,.25-.2,.04-.2-.09-.26-.14-.28l-19.23-8.56c-.92,.85-3,2.44-5.82,2.6-2.09,.13-4.16-.56-6.15-2.04Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.91,264.33l-2.25,22.53c-.22,2.24,1.2,4.3,3.37,4.9l24.52,6.68,.11-38.07-25.74,3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M431.53,299.73l-25.76-7.02c-2.64-.72-4.36-3.22-4.09-5.95l2.33-23.29,27.64-4.25-.12,40.52Zm-25.71-34.54l-2.18,21.77c-.18,1.76,.94,3.38,2.64,3.84l23.27,6.34,.1-35.62-23.84,3.67Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "412.06 298.82 417.41 356.3 408.1 408.54 425.16 408.54 440.32 349.01 435.8 298.44 412.06 298.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M425.93,409.53h-19.02l9.49-53.27-5.43-58.41,25.73-.41,4.62,51.66-.04,.16-15.35,60.27Zm-16.65-1.98h15.11l14.93-58.62-4.42-49.49-21.76,.35,5.26,56.55-.02,.13-9.1,51.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M422.73,301.29s-.66,17.82,21.52,45.79l-3.04,61.13,17.14-.28,8.83-64.7c.35-2.53-.05-5.11-1.14-7.42l-16.26-34.51h-27.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M440.17,409.22l3.07-61.82c-21.92-27.77-21.53-45.41-21.5-46.15l.04-.95h28.64l16.52,35.08c1.17,2.49,1.6,5.25,1.22,7.98l-8.94,65.54-19.05,.31Zm-16.42-106.94c.26,4.03,2.48,20.48,21.27,44.19l.23,.29-.02,.37-2.99,60.07,15.24-.25,8.71-63.86c.32-2.35-.04-4.72-1.05-6.87l-15.99-33.95h-25.41Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "493.05 200.85 491.07 200.85 491.07 195.06 513.47 195.06 513.47 183.2 487 183.2 487 181.22 515.45 181.22 515.45 197.04 493.05 197.04 493.05 200.85"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M440.96,245.39l-.41-12.08s12.62-2.92,2.64-25.74l-16.51,14.64,.48,24.96,13.8-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M426.19,248.29l-.51-26.52,17.87-15.85,.55,1.25c4.2,9.6,5.04,17.01,2.51,22.05-1.51,3.01-3.84,4.3-5.05,4.78l.41,12.24-15.79,2.04Zm1.49-25.64l.45,23.4,11.81-1.53-.41-11.99,.79-.18c.11-.03,2.9-.74,4.54-4.06,1.47-2.97,2.26-8.66-2.05-19.06l-15.14,13.43Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 490.2,
    y: 198.18,
    width: 3.73,
    height: 13.87
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M464.07,242.16c.8,0,14.13-1.32,14.13-1.32l10.4-24.53-1.6-9.07,3.2-4.53v5.07l8.8-1.6s3.47,5.6-4,12.27l-8.8,34.93-22.13,4.62v-15.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M463.08,259.21v-18.04h.99c.6,0,8.16-.73,13.45-1.26l10.05-23.72-1.62-9.18,5.24-7.42v7l8.3-1.51,.36,.57c.16,.26,3.74,6.27-3.95,13.32l-8.88,35.24-23.93,5Zm1.98-16.13v13.69l20.33-4.24,8.72-34.62,.23-.2c5.41-4.83,4.63-8.93,4.08-10.42l-9.21,1.68v-3.13l-1.16,1.65,1.58,8.95-.11,.27-10.63,25.07-.58,.06c-1.9,.19-10.28,1.02-13.24,1.26Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M409.24,249.1l16.16-8.52s9.07,2.4,15.73,0h25.6v18.51l-12.53,3.3-.27,46.98h-43.2l1.87-42.93h-10.67l7.3-17.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M454.93,310.37h-45.23l1.87-42.93h-11.13l8.02-19.06,16.83-8.87,.38,.1c.09,.02,8.85,2.29,15.14,.03l.16-.06h26.77v20.28l-12.54,3.3-.27,47.21Zm-43.15-2h41.16l.26-46.75,12.53-3.3v-16.74h-24.43c-6.15,2.13-13.94,.5-15.78,.06l-15.51,8.17-6.58,15.63h10.2l-1.87,42.93Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 473.22,
    y: 177.68,
    width: 36.71,
    height: 9.07
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 475.82,
    y: 175.28,
    width: 31.51,
    height: 14.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M508.32,190.4h-33.49v-16.11h33.49v16.11Zm-31.51-1.98h29.53v-12.15h-29.53v12.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M445.88,209.11h0c-.06-1.04-.9-2.8-4.62-5.27-5.74-3.83-12.05-2.87-17.9,3.49-2.11-2.27-6.18-5.89-8.55-3.05-1.86,2.23-4.16,7.9-3.72,10.76,.34,2.22,3.27,3.29,7.02,3.43,.55,.02,1.06,0,1.53-.06,1.32,6.3,6.72,11.94,6.72,11.94,10.82,1.35,12.35-5.38,12.54-10.56,.03-.87-1.32-1.32-1.32-3.3,0-.66,0-1.98,1.44-2.06,5.31-.81,6.51-3.41,6.78-4.65,.06-.17,.09-.4,.08-.66h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gear"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M628.01,41.17c-.53-2.13-1.42-4.27-2.49-6.22l2.13-4.98-7.47-7.29-4.98,2.13c-1.96-1.07-3.91-1.96-6.22-2.49l-1.78-5.16h-10.49l-1.96,5.16c-2.13,.53-4.27,1.42-6.22,2.49l-4.98-2.13-7.29,7.29,2.13,4.98c-1.07,1.96-1.96,3.91-2.49,6.22l-5.16,1.96v10.49l5.16,1.96c.53,2.13,1.42,4.27,2.49,6.22l-2.13,4.98,7.47,7.29,4.98-2.13c1.96,1.07,3.91,1.96,6.22,2.49l1.96,5.16h10.31l1.96-5.16c2.13-.53,4.27-1.42,6.22-2.49l4.98,2.13,7.47-7.29-2.13-4.98c1.07-1.96,1.96-3.91,2.49-6.22l5.16-1.96v-10.49l-5.33-1.96Zm-26.14,19.92c-7.11,0-12.8-5.69-12.8-12.8s5.69-12.8,12.8-12.8,12.8,5.69,12.8,12.8-5.69,12.8-12.8,12.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M631.04,90.07c.18-1.07,.18-1.96,0-3.02l1.78-1.78-1.78-4.45h-2.49c-.53-.71-1.42-1.42-2.13-2.13v-2.49l-4.45-1.78-1.78,1.78c-1.07-.18-1.96-.18-3.02,0l-1.78-1.78-4.45,1.78v2.49c-.71,.53-1.42,1.42-2.13,2.13h-2.49l-1.78,4.45,1.78,1.78c-.18,1.07-.18,1.96,0,3.02l-1.78,1.78,1.78,4.45h2.49c.53,.71,1.42,1.42,2.13,2.13v2.49l4.45,1.78,1.78-1.78c1.07,.18,1.96,.18,3.02,0l1.78,1.78,4.45-1.78v-2.49c.71-.53,1.42-1.42,2.13-2.13h2.49l1.78-4.45-1.78-1.78Zm-14.23,3.73c-3.02-1.24-4.45-4.62-3.2-7.47,1.24-3.02,4.62-4.45,7.47-3.2,3.02,1.24,4.45,4.62,3.2,7.47-1.24,3.02-4.62,4.45-7.47,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M654.33,66.77c.18-1.07,.18-1.96,0-3.02l1.78-1.78-1.78-4.45h-2.49c-.53-.71-1.42-1.42-2.13-2.13v-2.49l-4.45-1.78-1.78,1.78c-1.07-.18-1.96-.18-3.02,0l-1.78-1.78-4.45,1.78v2.49c-.71,.53-1.42,1.42-2.13,2.13h-2.49l-1.78,4.45,1.78,1.78c-.18,1.07-.18,1.96,0,3.02l-1.78,1.78,1.78,4.45h2.49c.53,.71,1.42,1.42,2.13,2.13v2.49l4.45,1.78,1.78-1.78c1.07,.18,1.96,.18,3.02,0l1.78,1.78,4.45-1.78v-2.49c.71-.53,1.42-1.42,2.13-2.13h2.49l1.78-4.45-1.78-1.78Zm-14.4,3.91c-3.02-1.24-4.45-4.62-3.2-7.47,1.24-3.02,4.62-4.45,7.47-3.2,3.02,1.24,4.45,4.62,3.2,7.47-1.07,3.02-4.45,4.45-7.47,3.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.78,389.4v-18.95h-12.9c-4.57,0-8.28-3.71-8.28-8.28v-33.19c0-4.39,3.56-7.94,7.94-7.94h0c4.39,0,7.94,3.56,7.94,7.94v27.35h5.29v-31.77c0-3.9,3.16-7.06,7.06-7.06h0c3.9,0,7.06,3.16,7.06,7.06v10.59h7.06v-25.59c0-4.39,3.56-7.94,7.94-7.94h0c4.39,0,7.94,3.56,7.94,7.94v29.23c0,4.81-3.9,8.71-8.71,8.71h-14.23v41.9h-14.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "29.04 382.8 75.24 382.8 68.64 425.04 35.64 425.04 29.04 382.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.49,426.03H34.79l-6.91-44.22h48.51l-6.91,44.22Zm-33-1.98h31.31l6.29-40.26H30.2l6.29,40.26Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintains);
export default __webpack_public_path__ + "static/media/Maintains.c67c37b59126cfcb03578afbca80ec8f.svg";
export { ForwardRef as ReactComponent };